import Note from "../models/note";
import ModuleController from "./ModuleController";

export default class NoteController extends ModuleController {
    constructor(note) {
        super();
        this.note = note;
        this.animate = false;
    }

    getNote() {
        return this.note;
    }

    setNote(newNote) {
        this.note = newNote;
    }

    // Creates a new Note object from data
    // Runs reload on subject
    editNote(newNoteData={}) {
        this.note = new Note(newNoteData);
        this.subject.runReload();
    }
}